import { useLocation } from "react-router-dom";
import ModelViewer from "./ModelViever";

export function ModelViewerWrapper() {
  const location = useLocation();
  const state = location.state as {
    modelPath: string;
    rotationY?: number;
    iosSrc?: string;
  };

  return (
    <ModelViewer
      modelPath={state.modelPath}
      rotationY={state.rotationY}
      iosSrc={state.iosSrc}
    />
  );
}
